import { Injectable } from '@angular/core';
import { BridgeManagerModule } from './bridge-manager.module';
import { LoggerService } from '../common/logger.service';
import { WindowService } from '../common/window.service';
import { delay } from '../util.class';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: BridgeManagerModule,
  deps: [WindowService, LoggerService],
})
export class BridgeConnectorService {
  private readonly pInstance: Promise<object>;
  private pResolve: Function;

  public isWebView = false;
  isAnExternalAnchor: boolean;

  constructor(private _window: WindowService, private logger: LoggerService) {
    this.init = this.init.bind(this);

    this.pInstance = new Promise(resolve => (this.pResolve = resolve));

    this._window.native.BWB_init = this.init;

    this.isAnExternalAnchor = window.location.href.indexOf('external-anchors') >= 0 ?? false;

    if (this.isAnExternalAnchor || environment.inBrowser || this.logger.config.isInEditor) {
      this.init(false);
    } else {
      // first was 2000 ms
      const toId = setTimeout(() => this.init(false), 10000);
      this._window.native.BWB_init = () => {
        clearTimeout(toId);
        this.init(true);
      };
    }
  }

  toPromise(): Promise<object> {
    return this.pInstance;
  }

  init(inApp: boolean): void {
    if (inApp) {
      this.isWebView = true;
      this._window.native.BWB_JS.isWebView = this.isWebView;
    } else {
      this._window.native.BWB_JS = {
        isWebView: this.isWebView,
        execute: (name: string, params: any, callbackName: string) => {
          if (!this.isAnExternalAnchor) {
            this.logger.warn('BWB_JS doesn\'t work', callbackName);
            this.logger.datadog(new Error('BWB_JS doesn\'t work due to more than 10s to open a window.'));
          }

          delay(() => {
            if (typeof this._window.native[callbackName] === 'function') {
              (this._window.native[callbackName] as Function).apply(this._window.native[callbackName], [{}]);
            }
          }, 500);
        },
      };
    }

    this.pResolve(this._window.native.BWB_JS);
  }
}
